import DownloadIcon from "@mui/icons-material/Download";
import { Box, Grid, Typography, styled } from "@mui/material";
import { Helmet } from "react-helmet-async";
import UnderlineB from "../components/UnderlineB";
import UnderlineT from "../components/UnderlineT";
import AfterExposureImpactedTooth from "../documents/AfterExposureImpactedTooth.pdf";
import AfterMultipleTeeth from "../documents/AfterMultipleTeeth.pdf";
import AfterPlacementImplants from "../documents/AfterPlacementImplants.pdf";
import AfterToothExtraction from "../documents/AfterToothExtraction.pdf";
import AfterWisdomTooth from "../documents/AfterWisdomTooth.pdf";
import GeneralInstructionsAfterSurgery from "../documents/GeneralInstructionsAfterSurgery.pdf";
import AnesthesiaMarkiewicz from "../documents/AnesthesiaMarkiewicz.pdf";
import AnesthesiaShurenTec from "../documents/AnesthesiaShurenTec.pdf";
import AnesthesiaStaplefordTec from "../documents/AnesthesiaStaplefordTec.pdf";
import BeforeSurgery from "../documents/BeforeSurgery.pdf";
import ConeBeamCT from "../documents/ConeBeamCT.pdf";
import Consultation from "../documents/Consultation.pdf";
import FinancialInformation from "../documents/FinancialInformation.pdf";
import GLOMSConsult from "../documents/GLOMSConsult.pdf";
import ImplantsMarkiewicz from "../documents/ImplantsMarkiewicz.pdf";
import ImplantsShuren from "../documents/ImplantsShuren.pdf";
import ImplantsStapleford from "../documents/ImplantsStapleford.pdf";
import PrivacyCode from "../documents/PrivacyCode.pdf";
import Questionaire from "../documents/Questionaire.pdf";
import Scheduling from "../documents/Scheduling.pdf";
import GreatLakesLogo from "../img/GreatLakesLogo.png";

const A = styled("a")({
  display: "flex",
  width: "max-content",
  textDecoration: "none",
  alignItems: "center",
  margin: "10px",
  backgroundImage: "radial-gradient(rgb(68, 199, 205,0.3), white)",
  backgroundSize: "0% 0%",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  transition: "background-size .5s, color .5s",
  transformOrigin: "center",

  "&:hover": {
    // transition: "all .2s ease-in-out",
    // transform: "scale(1.1)",
    backgroundSize: "95% 40%",
    backgroundPostition: "center",
  },
});

function Item(props) {
  return (
    <A href={props.link} target="_blank" rel="noreferrer" alt="Download form">
      <DownloadIcon
        sx={{ display: "inline-flex" }}
        fontSize="large"
        color="teal"
      />
      <Typography color="text.primary" sx={{ display: "inline-flex" }}>
        {props.text}
      </Typography>
    </A>
  );
}

function Downloads() {
  return (
    <Box sx={{ minHeight: "100vh", padding: "150px 0px" }}>
      <Helmet>
        <title>
          Downloads - Great Lakes Oral & Maxillofacial Surgery Centre
        </title>
        <meta
          name="description"
          content="Download patient forms, including consent for implants and anesthesia, at Great Lakes Oral & Maxillofacial Surgery Centre."
        />
        {/* End standard metadata tags */}
        {/* Facebook tags */}
        <meta property="og:type" content="website" />
        <meta property="og:image" content={GreatLakesLogo} />
        <meta
          property="og:title"
          content="Downloads - Great Lakes Oral & Maxillofacial Surgery Centre"
        />
        <meta
          property="og:url"
          content="http://www.greatlakessurgerycentre.com/downloads"
        />
        <meta
          property="og:description"
          content="Download patient forms, including consent for implants and anesthesia, at Great Lakes Oral & Maxillofacial Surgery Centre."
        />
        {/* End Facebook tags */}
        {/* Twitter tags */}

        {/* End Twitter tags */}
      </Helmet>
      <Typography variant="h4" sx={{ width: "100%", textAlign: "center" }}>
        Forms and Downloads <UnderlineT />
      </Typography>
      <Grid container justifyContent="space-evenly" sx={{ marginTop: "2%" }}>
        <Grid
          container
          item
          sx={{ maxWidth: "max-content", margin: "0 2%" }}
          flexDirection="column"
          alignItems="center"
        >
          <Typography variant="h5" sx={{ marginTop: "40px" }}>
            Anesthesia Consent Forms
            <UnderlineB />
          </Typography>
          <Box>
            <Item
              text="Anesthesia - Dr. Shuren's Patients"
              link={AnesthesiaShurenTec}
            />
            <Item
              text="Anesthesia - Dr. Stapleford's Patients"
              link={AnesthesiaStaplefordTec}
            />
            <Item
              text="Anesthesia - Dr. Markiewicz's Patients"
              link={AnesthesiaMarkiewicz}
            />
          </Box>
        </Grid>

        <Grid
          item
          container
          flexDirection="column"
          alignItems="center"
          sx={{ maxWidth: "max-content", margin: "0 2%" }}
        >
          <Typography variant="h5" sx={{ marginTop: "40px" }}>
            Implant Consent Forms
            <UnderlineB />
          </Typography>
          <Box>
            <Item
              text="Implants - Dr. Shuren's Patients"
              link={ImplantsShuren}
            />
            <Item
              text="Implants - Dr. Stapleford's Patients"
              link={ImplantsStapleford}
            />
            <Item
              text="Implants - Dr. Markiewicz's Patients"
              link={ImplantsMarkiewicz}
            />
          </Box>
        </Grid>
        <Grid
          container
          item
          sx={{ maxWidth: "max-content", margin: "0 2%" }}
          flexDirection="column"
          alignItems="center"
        >
          <Typography variant="h5" sx={{ marginTop: "40px" }}>
            Patient Referral Forms
            <UnderlineB />
          </Typography>
          <Box>
            <Item
              text="TMJ Surgical Consult Request Questionnaire"
              link={GLOMSConsult}
            />
          </Box>
        </Grid>
        <Grid
          item
          container
          sx={{ maxWidth: "max-content", margin: "0 2%" }}
          flexDirection="column"
          alignItems="center"
        >
          <Typography variant="h5" sx={{ marginTop: "40px" }}>
            Patient Downloads
            <UnderlineB />
          </Typography>
          <Box>
            <Item text="Consultation" link={Consultation} />
            <Item text="Scheduling Information" link={Scheduling} />
            <Item text="Patient Billing" link={FinancialInformation} />
            <Item text="Health Questionaire" link={Questionaire} />
            <Item text="Privacy Policy" link={PrivacyCode} />
            <Item text="Instructions Before Surgery" link={BeforeSurgery} />
            <Item text="Cone Beam CT Scan Referral" link={ConeBeamCT} />
          </Box>
        </Grid>
        <Grid
          item
          container
          sx={{ maxWidth: "max-content", margin: "0 2%" }}
          flexDirection="column"
          alignItems="center"
        >
          <Typography variant="h5" sx={{ marginTop: "40px" }}>
            After Surgery Instructions
            <UnderlineB />
          </Typography>
          <Box>
            <Item
              text="General Instructions After Surgery"
              link={GeneralInstructionsAfterSurgery}
            />
            <Item
              text="After Wisdom Tooth Removal"
              link={AfterWisdomTooth}
            />
            <Item
              text="After Tooth Extraction"
              link={AfterToothExtraction}
            />
            <Item
              text="After the Removal of Multiple Teeth"
              link={AfterMultipleTeeth}
            />
            <Item
              text="After Placement of Dental Implants"
              link={AfterPlacementImplants}
            />
            <Item
              text="After Exposure of an Impacted Tooth"
              link={AfterExposureImpactedTooth}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Downloads;
